export default __webpack_public_path__ + "static/media/ic_atom_40.25e15d89.svg";